import React from 'react';
import Notification from '~/containers/Views/Notification/Notification.ui';

function FormPrepagoComponent({
  showSelect,
  modalTokenPlaceholder,
  handleChangeToken,
  currentNumberSelected,
  handleChangeNumber,
  retrieveList,
  error,
  btnText,
  validateRetrieveList,
  inputState,
  setInputState,
  handleSubmitWithSelect,
  btnTextRetrieve,
}) {
  const handleOnChange = (e) => {
    handleChangeToken(e);
    setInputState(e.target.value);
  };
  return (
    <form name="validateToken" onSubmit={e => validateRetrieveList(e)}>
      <div className="mb-3">
        <input
          type="text"
          placeholder={modalTokenPlaceholder}
          className="form-control inputCode"
          //   onChange={handleChangeToken}
          onChange={e => handleOnChange(e)}
          required
          minLength={8}
          maxLength={30}
          value={inputState}
        />
      </div>
      {showSelect && (
        <div className="mb-3">
          <select
            className="form-select inputCode"
            value={currentNumberSelected}
            onChange={e => handleChangeNumber(e)}
          >
            <option value="0" disabled>
              Selecciona un servicio a renovar
            </option>
            {retrieveList.map((item, index) => (
              <option key={index} value={item.virtual_number}>
                {item.virtual_number}
              </option>
            ))}
          </select>
        </div>
      )}

      {error && <Notification title={error} />}
      {showSelect ? (
        <button className="red-claro-btn FirstBtn" type="button" onClick={() => handleSubmitWithSelect()}>
          <span>{btnTextRetrieve}</span>
        </button>
      ) : (
        <button className="red-claro-btn FirstBtn" type="submit">
          <span>{btnText}</span>
        </button>
      )}
    </form>
  );
}

export default FormPrepagoComponent;
